import { render, staticRenderFns } from "./ControlTabComponent.vue?vue&type=template&id=579a3cc4&scoped=true"
import script from "./ControlTabComponent.js?vue&type=script&lang=js&external"
export * from "./ControlTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ControlTabComponent.vue?vue&type=style&index=0&id=579a3cc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a3cc4",
  null
  
)

export default component.exports